import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../../../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import Scenario7Transfusion, { scenario7TransfusionAudioCaching, scenario7TransfusionVideoSegments } from "../../../Scenario7-transfusion";
import { TransfusionComponentsStep1ComponentPart1Config, TransfusionComponentsStep1ComponentMainConfig } from "../transfusion-components-step1";

export default class TransfusionComponentsStep1Part1 extends BaseScenarioPart<GameBaseScenario> {
	private stepName = 'Step 2'
	private get config(): TransfusionComponentsStep1ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: TransfusionComponentsStep1ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(6);
		this.mainConfig.scenario.uiWrapper.displayMixedMediaUI({
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			htmlData: `
			<p class="default-text add-pad">For the substitution test, you approach other employees and inquire as to whether they would do the same 
			thing in similar circumstances.<br/><br/>
			Nurse #1: I would immediately stop the blood and disconnect the tubing, 
			then notify my manager, the blood bank, then the doctor. After I take all the necessary steps to 
			ensure the patients’ safety, I would complete an incident report.<br/><br/>
			Nurse #2: Oh, I don’t see how that could happen since we co-sign with 
			another RN at the bedside, however, if it did happen, I would stop the blood the moment the error 
			was discovered, disconnect the tubing, then notify my manager, the blood bank, and the doctor. I 
			would submit an incident report right after that.<br/><br/>
			Nurse #3: I’ve never heard of this happening. With our current policies and 
			protocols, it is extremely unlikely for this to happen.</p>
			`,
			okButton: 'Continue',
			talkingVideoSrc: scenario7TransfusionVideoSegments.getItemByKey('MixedMedia').src,
			talkingVideoChapterId: scenario7TransfusionVideoSegments.getItemByKey('MixedMedia').chapterIds[0],
			onContinueClicked: () => {
				context.section2();
			}
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario7TransfusionAudioCaching.getItemByKey(scenario7TransfusionAudioCaching.audioKeys.question3).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 1'),
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. The other nurses stated that they would not do the same thing in similar circumstances.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. When asked, the other nurses stated that they would not do 
				the same thing in similar circumstances. None of the staff discussed the effects of high workload creating 
				pressure to sometimes take short cuts.</p>
			`,
			question: 'Given the information received from staff interviews, is it reasonable to conclude that a systems or cultural issue exists, and other employees in that work area would behave the same way in a similar situation?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario7TransfusionVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, (this.stepName + ' - Question 1 '), parentQuestion, () => {
					context.section3();
				}, () => {
					context.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[6], mentorInfo.chapterIds[7]);
			}
		},2);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			audioUrl: scenario7TransfusionAudioCaching.getItemByKey(scenario7TransfusionAudioCaching.audioKeys.question4).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the substitution test, the accountability for this action…',
			options: [
				{
					title: 'Lies completely with the employee.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. The substitution test demonstrates that no other employees 
						would make a similar choice and there are no system or cultural issues identified. Accountability 
						for the employee’s choice rests completely with them.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				},
				{
					title: 'Is shared between the employee and organizational leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best choice - The substitution test demonstrates 
						that no other employees would make a similar choice and there are no system or cultural 
						issues identified. Accountability for the employee’s choice rests completely with them.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Lies solely with the leadership.',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the best option. The substitution test demonstrates 
						that there are no system or cultural issues identified. Accountability for the employee’s 
						choice rests completely with them.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario7TransfusionVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[8], mentorInfo.chapterIds[9], mentorInfo.chapterIds[10], 'Is shared between the employee and organizational leadership.');
			}
		},3);
	}
}